import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import { BaseValidator } from '@tcm-modules/tcm-core.module';
import mnt from 'moment';
const moment = mnt;

@Directive({
    selector: '[conditionalTimeLessThan]',
    providers: [{ provide: NG_VALIDATORS, useExisting: ConditionalTimeLessThanValidatorDirective, multi: true }],
    standalone: false
})
export class ConditionalTimeLessThanValidatorDirective extends BaseValidator implements OnChanges {

    @Input()
    conditionalTimeLessThan: { to: string };

    @Input('conditionalStartValue')
    conditionalStartValue: string ;

    @Input('conditionalEndValue')
    conditionalEndValue: string ;

    @Input('conditionalTimeLessThanFieldName')
    fieldName: string;

    constructor() {
        super('timeLessThan');
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.conditionalTimeLessThan && changes.conditionalTimeLessThan.isFirstChange()) {
            return;
        }

        this._onChange();
    }

    protected getValidationResult(control: any) {
        
        if (!control.value || !this.conditionalTimeLessThan.to)
            return null;

        // local variables - Time Window
        const from = moment(control.value, 'HH:mm:ss');
        const to = moment(this.conditionalTimeLessThan.to, 'HH:mm:ss');
        // local variables - Date Window
        const start = new Date(this.conditionalStartValue);
        const end   = new Date(this.conditionalEndValue);

        // Check the start and end window of the additional condition.
        if (start != null && end > start) {
            return null; 
        }

        const fromMinutes = from.get('hour') * 60 + from.get('minute');
        const toMinutes = to.get('hour') * 60 + to.get('minute');
        if (fromMinutes < toMinutes) {
            return null;
        }

        return this.buildValidationErrorResult({ fieldName: this.fieldName });
    }
}

